import React, { useState } from "react";
import { Button, Col, Container, Dropdown, Form, Modal, Row } from "react-bootstrap";
// css
import styles from "./StaffClientsModal.module.scss";
import { Link, useNavigate, useParams } from "react-router-dom";
import LoadingIndicator from "components/shared/LoadingIndicator";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingOverlay from "components/shared/LoadingOverlay";
import TableLayout from "components/TableLayout";
import { CstmPagination } from "components/Common/Common";
import { useGetStaffClientsListQuery } from "store/services/staff";
import TableHeader from "components/shared/FormComponents/TableHeader";
import { MANAGE_STAFF, MANAGE_STAFF_TASK_LIST } from "config/paths";
import { CloseIcon } from "Assets/icons";
import { useListClassroomReportsQuery } from "store/services/clients/reports-v2/classroomReport";
import { dateFormat } from "helpers/common";
import { useLazyGetFileUrlQuery } from "store/services/utility";

const ClassroomReportsModal = ({ currentEntry, show, setShow }) => {

    //   const { id: staffId, taskType } = useParams();
    const navigate = useNavigate()

    const [pageSize, setPageSize] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [filter, setFilter] = useState({ search: "", task_type: "single", sort: { column: "id", direction: "DESC" } });

    const [getFileUrl, { isLoading: getFileLoading, isFetching: getFileFetching }] = useLazyGetFileUrlQuery();
    const { data, isLoading, isError, isFetching } = useListClassroomReportsQuery({ classroomId: currentEntry?.id, ...filter, limit: pageSize, page: currentPage }, { skip: !currentEntry?.id });
    const totalRecords = data?.totalRecords || 0;
    const totalPages = Math.ceil(totalRecords / pageSize);

    const handleViewPdf = async (name) => {

        try {
            const url = await getFileUrl(name).unwrap();
            if (url) window.open(url, '_blank');

        } catch (err) { console.error("Error assigning therapist", err); }
    };

    const column = [
        {
            head: "Created At",
            accessor: "createdAt",
            isComponent: true,
            component: (item, ind) => (
                <h6 className="m-0 fw-sbold">{dateFormat(item?.pdfList?.[0]?.createdAt) || "--"}</h6>
            ),
        },
        {
            head: "Action",
            accessor: "action",
            isComponent: true,
            component: (item, ind) => (
                <div className="ActnBtn d-flex align-items-center  gap-10">
                    <Button
                        type="button"
                        className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold"
                        style={{ height: "30px", width: "60px", minWidth: "60px" }}
                        disabled={getFileFetching}
                        onClick={() => handleViewPdf(item?.pdfList?.[0]?.attachment_key)}
                    >
                        View
                    </Button>
                </div>
            ),
        }
    ];
    const resetFilter = () => {
        setFilter((prev) => ({ ...prev, search: "", sort: { column: "id", direction: "desc" } }));
        setCurrentPage(1)
    };

    const handleFilterChange = (key) => (value) => {
        setFilter((prevState) => ({
            ...prevState,
            [key]: value,
        }));
        setCurrentPage(1); // Reset to first page when filter changes
    };

    const handlePageChange = (page) => {
        window.scrollTo(0, 0);
        setCurrentPage(page);
    };

    const handlePopup = () => setShow(false)

    return (
        <>
            <Modal
                show={show}
                className={`${styles.AssignChecklist}  AssignChecklist`}
                onHide={handlePopup}
                backdrop="static"
                keyboard={false}
                centered
                scrollable="true"
                size="lg"
            >
                <Modal.Body className={`${styles.modalBody} position-relative rounded`}>
                    <div onClick={handlePopup} style={{ display: "inline-block" }}>
                        <Button

                            className="cursor-pointer border-0 p-0 position-absolute"
                            variant="transparent"
                            style={{ right: 15, top: 10, cursor: "pointer", lineHeight: "0", verticalAlign: "middle" }}
                        >
                            <CloseIcon />
                        </Button>
                    </div>
                    {/* <div>
                        <h6 className="m-0 fw-bold themeBlue">Pre-Appointment Form Submitted by Guardian.</h6>
                    </div> */}
                    <section
                        className={`${styles.ClientDetail} position-relative ClientDetail`}
                    >
                        <Container fluid>
                            <Row>
                                <Col
                                    lg="12"
                                    className=""
                                >
                                    <Row>
                                        <Col lg="12" className="my-3">
                                            {/* <div className="my-3">
                                                <ul className="list-unstyled mb-0 d-flex align-items-center">
                                                    <li className="m-0 p-0">
                                                        <Link
                                                            className="themeBlue fw-sbold"
                                                            style={{ textDecoration: "underline" }}
                                                            to={MANAGE_STAFF}
                                                        >
                                                            Manage Staff
                                                        </Link>
                                                    </li>
                                                    <li className="">
                                                        <h5 className="m-0 fw-bold themeBlue">
                                                            / Clients
                                                        </h5>
                                                    </li>
                                                </ul>
                                            </div> */}
                                            <div className="pageHead d-flex align-items-center justify-content-between flex-wrap gap-10">
                                                <div className="left">
                                                    <TableHeader
                                                        heading={"Classroom Consultation Plan Reports"}
                                                        // handleFilterChange={handleFilterChange}
                                                        // filter={filter}
                                                        // resetFilter={resetFilter}
                                                        // searchPlaceholder="Client Last, First Name"
                                                        hideSearch={true}
                                                        hideFilters={true}
                                                    />
                                                </div>
                                            </div>
                                        </Col>
                                        <Col lg="12" className="my-2">
                                            <div className="table-outer">
                                                {isFetching ? (
                                                    <div style={{ height: "200px" }}>
                                                        <LoadingIndicator />
                                                    </div>
                                                ) : isError ? (
                                                    <ErrorComponent />
                                                ) : (
                                                    <>
                                                        {(isFetching || getFileFetching) && <LoadingOverlay />}
                                                        <TableLayout
                                                            height="calc(100vh - 320px)"
                                                            data={data?.records || []}
                                                            column={column}
                                                        // url={MANAGE_STAFF_TASK_LIST.replace(":taskType", taskType).replace(":staffId", staffId).replace("/:clientId", "")}
                                                        />
                                                    </>
                                                )}
                                                <CstmPagination
                                                    totalPages={totalPages}
                                                    activePage={currentPage}
                                                    handlePageChange={handlePageChange}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>

                        </Container>
                    </section>

                </Modal.Body>
            </Modal >
        </>
    );
};

export default ClassroomReportsModal;